export const generalMessage = {
  unexpectedError: "Erreur inattendue, veuillez réessayer",
};
